module.exports = {"450512100":"南康镇","450512101":"营盘镇","450512102":"兴港镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/450512.json
// module id = 1944
// module chunks = 0